/**
 * Price-lock countdown shared by cart page and cart drawer.
 * Uses sessionStorage key cartTimerEnd so both views stay in sync.
 */
(function () {
  if (window.__cartPriceLockTimerInit) return;
  window.__cartPriceLockTimerInit = true;

  const STORAGE_KEY = 'cartTimerEnd';
  let timerInterval = null;
  let lastCartCount = 0;
  let cartCheckInterval = null;
  let timerMinutes = 0;

  function getTimerMinutes() {
    const boxes = document.querySelectorAll('[data-cart-timer-minutes]');
    if (!boxes.length) return 0;
    return Math.max(
      ...Array.from(boxes).map((box) => parseInt(box.dataset.cartTimerMinutes, 10) || 0)
    );
  }

  function getDisplays() {
    return document.querySelectorAll('.cart-timer-time');
  }

  function formatCountdown(distance) {
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  function updateTimerDisplay(distance) {
    const text = formatCountdown(distance);
    getDisplays().forEach((display) => {
      display.textContent = text;
    });
  }

  function setInitialDisplay(minutes) {
    const text = `${minutes < 10 ? '0' : ''}${minutes}:00`;
    getDisplays().forEach((display) => {
      display.textContent = text;
    });
  }

  function clearTimerDisplay() {
    getDisplays().forEach((display) => {
      display.textContent = '00:00';
    });
  }

  function startTimerInterval(endTime) {
    if (timerInterval) clearInterval(timerInterval);

    timerInterval = setInterval(() => {
      const distance = endTime - Date.now();

      if (distance <= 0) {
        clearInterval(timerInterval);
        timerInterval = null;
        clearTimerDisplay();
        sessionStorage.removeItem(STORAGE_KEY);
        setTimeout(() => window.location.reload(), 500);
      } else {
        updateTimerDisplay(distance);
      }
    }, 1000);
  }

  function startCartTimer() {
    timerMinutes = getTimerMinutes();
    if (timerMinutes <= 0) return;

    const endTime = Date.now() + timerMinutes * 60 * 1000;
    sessionStorage.setItem(STORAGE_KEY, String(endTime));
    setInitialDisplay(timerMinutes);
    startTimerInterval(endTime);
  }

  function resumeCartTimer() {
    timerMinutes = getTimerMinutes();
    if (timerMinutes <= 0) return;
    if (!getDisplays().length) return;

    const stored = sessionStorage.getItem(STORAGE_KEY);
    const now = Date.now();

    if (!stored || parseInt(stored, 10) <= now) {
      startCartTimer();
      return;
    }

    startTimerInterval(parseInt(stored, 10));
  }

  function checkCartAndStartTimer() {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        if (cart.item_count > 0 && lastCartCount === 0) {
          lastCartCount = cart.item_count;
          sessionStorage.removeItem(STORAGE_KEY);
          startCartTimer();
          stopCartPoll();
        } else if (cart.item_count > 0) {
          lastCartCount = cart.item_count;
          resumeCartTimer();
        } else if (cart.item_count === 0 && lastCartCount > 0) {
          lastCartCount = 0;
          if (timerInterval) clearInterval(timerInterval);
          timerInterval = null;
          sessionStorage.removeItem(STORAGE_KEY);
          clearTimerDisplay();
        }
      })
      .catch((error) => console.error('[cart-price-lock-timer]', error));
  }

  function stopCartPoll() {
    if (!cartCheckInterval) return;
    clearInterval(cartCheckInterval);
    cartCheckInterval = null;
  }

  function startCartPoll() {
    if (cartCheckInterval) return;
    cartCheckInterval = setInterval(checkCartAndStartTimer, 500);
    setTimeout(stopCartPoll, 5000);
  }

  function init() {
    timerMinutes = getTimerMinutes();
    if (timerMinutes <= 0) return;

    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        lastCartCount = cart.item_count;
        if (cart.item_count > 0) resumeCartTimer();
      });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('cartDrawerOpened', () => {
    resumeCartTimer();
  });
  document.addEventListener('afterCartChanged', () => {
    setTimeout(checkCartAndStartTimer, 100);
  });
  document.addEventListener('afterUpdateQuantity', resumeCartTimer);
  window.addEventListener(
    'cart-updated',
    () => {
      setTimeout(checkCartAndStartTimer, 100);
    },
    true
  );
  document.addEventListener('product-form:submitted', startCartPoll);
  document.addEventListener(
    'submit',
    (e) => {
      if (e.target.classList.contains('freq-added-form') || e.target.closest('.freq-added-form')) {
        checkCartAndStartTimer();
      }
    },
    true
  );
  document.addEventListener(
    'click',
    (e) => {
      if (
        (e.target.classList.contains('cart-submit-button') ||
          e.target.closest('.cart-submit-button') ||
          e.target.closest('button[name="add"]') ||
          e.target.classList.contains('freq-added-btn') ||
          e.target.closest('.freq-added-btn')) &&
        lastCartCount === 0
      ) {
        startCartPoll();
      }
    },
    true
  );
})();
